<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-button type="primary" :disabled="selectedRowKeysTabItems.length < 1" @click="profit"> 盘盈入库 </a-button>
			<a-button type="primary" :disabled="selectedRowKeysTabItems.length < 1" @click="loss"> 盘亏出库 </a-button>
		</div>
		<div class="content_main_top">
			<a-input class="a_select_self margin_self" v-model="serchInfo.name" allowClear placeholder="请输入物品名称"
			 @keyup.enter.native="serch_get_lis" />
			<a-input class="a_select_self margin_self" v-model="serchInfo.spu_sn" allowClear placeholder="请输入物品编号"
			 @keyup.enter.native="serch_get_lis" />
			<a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
			<a-button type="primary" ghost @click="result"> 重置 </a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :data-source="lis" bordered :loading="loading" :pagination="pagination" @change="handleTableChange" :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
			 rowKey="id" :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChange }">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}</template>
				</a-table-column>
				<a-table-column key="company_name" title="所属公司" ellipsis="true" data-index="company_name" />
				<a-table-column key="spu_type" title="类别" ellipsis="true" data-index="spu_type">
					<template scope="text,record">
						{{ text ? goodsTypeObj[text] : '' }}
					</template>
				</a-table-column>
				<a-table-column key="spu_sn" title="物品编号" ellipsis="true" data-index="spu_sn" />
				<a-table-column key="name" title="物品名称" ellipsis="true" data-index="name" />
				<a-table-column key="model" title="规格型号" ellipsis="true" data-index="model" />
				<a-table-column key="storage_num" title="数量" ellipsis="true" data-index="storage_num" />
				<a-table-column key="unit" title="单位" ellipsis="true" data-index="unit" width="120px" />
				<a-table-column key="price" title="采购均价" ellipsis="true" data-index="price" width="120px" />
				<a-table-column key="is_inspected" title="是否检定" ellipsis="true" data-index="is_inspected" width="120px">
					<template scope="text,record">
						{{ instrumentMap[text] }}
					</template>
				</a-table-column>
				<a-table-column key="create_by" title="录入人" ellipsis="true" data-index="create_by" />
				<a-table-column key="create_time" title="录入时间" ellipsis="true" data-index="create_time" />
				<a-table-column key="update_by" title="维护人" ellipsis="true" data-index="update_by" />
				<a-table-column key="update_time" title="维护时间" ellipsis="true" data-index="update_time" width="120px" />
				<a-table-column title="操作" width="150px">
					<template scope="text,record">
						<a @click="details(record)">详情</a>
					</template>
				</a-table-column>
			</a-table>
		</div>
		<a-modal title="流动资产-详情" :visible="detailsvisible" @cancel="detailsvisible=false" width="60%">
			<template slot="footer">
				<a-button key="back" @click="detailsvisible=false"> 取消 </a-button>
			</template>
			<a-form-model :model="detailsrow" style="height: 450px">
				<a-form-model-item label="物品编号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.spu_sn }}</span>
				</a-form-model-item>
				<a-form-model-item label="品类名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.name }}</span>
				</a-form-model-item>
				<a-form-model-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.model }}</span>
				</a-form-model-item>
				<a-form-model-item label="数　　量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.storage_num }}</span>
				</a-form-model-item>
				<a-form-model-item label="采购均价" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.price }}</span>
				</a-form-model-item>
				<a-form-model-item label="单　　位" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.unit }}</span>
				</a-form-model-item>
				<a-form-model-item label="类　　别" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.spu_type?goodsTypeObj[detailsrow.spu_type]:'' }}</span>
				</a-form-model-item>
				<a-form-model-item label="是否已检定" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
				</a-form-model-item>
				<a-form-model-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.company_name }}</span>
				</a-form-model-item>
				<a-form-model-item label="备　　注" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.notes }}</span>
				</a-form-model-item>
				<a-form-model-item label="录入时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.create_time }}</span>
				</a-form-model-item>
				<a-form-model-item label="录 入 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.create_by }}</span>
				</a-form-model-item>
				<a-form-model-item label="维护时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.update_time }}</span>
				</a-form-model-item>
				<a-form-model-item label="维 护 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.update_by }}</span>
				</a-form-model-item>
				<a-form-model-item label="是否为制毒、制爆" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.hazard_type ? detailsrow.hazard_type.replace('其他;', '').replace(/;/g, '、') : '' }}</span>
				</a-form-model-item>
				<a-form-model-item label="存放条件" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.storage_cond ? detailsrow.storage_cond.replace('其他;', '').replace(/;/g, '、') : '' }}</span>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<consumables-application :selected="{selectedRowKeysTabItems,selectedRowKeysTab}" ref="consumablesapplication" @ok="handleOk"/>
	</div>
</template>
<script>
	import {
		consumablesList,
		consumables_save,
		consumables_code
	} from '@/api/assetmenag'
	import ConsumablesApplication from '@/components/module/ConsumablesApplication'
	export default {
		components: {
			ConsumablesApplication
		},
		data() {
			return {
				selectedRowKeysTab: [],
				selectedRowKeysTabItems: [],
				labelCol3: {
					span: 2,
				},
				wrapperCol3: {
					span: 22,
				},
				labelCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 8,
					},
				},
				wrapperCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 16,
					},
				},
				serchInfo: {},
				scroll_y: 150,
				loading: false,
				lis: [],
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				isinventoryNum: false,
				detailsrow:{},
				detailsvisible:false,
			}
		},
		mounted() {
			this.get_list()
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 90
				}, 1000)
			})
		},
		methods: {
			handleOk(){
				this.selectedRowKeysTab=[]
			},
			profit(){
				this.$refs.consumablesapplication.showprofit()
			},
			loss(){
				this.$refs.consumablesapplication.showloss()
			},
			details(row) {
				this.detailsvisible = true
				this.detailsrow = row
				this.detailsrow.att_paths = row.att_path ? row.att_path.split(',') : []
			},
			// 详情
			show_details(record) {
				this.$refs.inventorymodal.show({
					businessKey: record.buId,
				})
			},
			onSelectChange(selectedRowKeys, selectedRows) {
				var arr = JSON.parse(JSON.stringify(selectedRows))
				this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.concat(arr)
				this.selectedRowKeysTab = selectedRowKeys
				var obj = {}
				this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeysTab.forEach((key, idx) => {
					this.selectedRowKeysTabItems.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.selectedRowKeysTabItems = newLis
				console.log(newLis)
			},
			result() {
				this.serchInfo = {}
			},
			//获取列表
			get_list() {
				// spu_get_list
				consumablesList({
					pageIndex: this.pagination.current,
					pageSize: this.pagination.pageSize,
					name: this.serchInfo.name,
					spuSn: this.serchInfo.spu_sn,
					sortField: 'id',
					sortOrder: 'desc' 
				}).then((res) => {
					console.log(res)
					if (res.code == 200) {
						var lis = res.data.list
						var arry = []
						res.data.list.forEach(item => {
							var a = {}
						var a = {
							id: item.id,
							storage_num: item.storageNum,
							average_price: item.averagePrice,
							is_inspected_name: item.isInspectedName,
							update_time: item.updateTime,
							update_by: item.updateBy,
							create_time: item.createTime,
							create_by: item.createBy,
							price: item.price,
						    company_name: item.companyName,
						    spu_type: item.spuType,
							spu_type_name: item.spuTypeName,
						    name: item.name,
						    model: item.model,
						    // storageNum: item.storageNum,
						    unit: item.unit,
						    is_inspected: item.isInspected,
						    state: item.state,
						    hazard_type: item.hazardType,
						    stable_lmt: item.stableLmt,
						    factory_batch: item.factoryBatch,
						    storage_loc: item.storageLoc,
						    storage_cond: item.storageCond,
						    purchase_time: item.purchaseTime,
						    purchase_price: item.purchasePrice,
						    value: item.value,
						    arrive_time: item.arriveTime,
						    dealer: item.dealer,
						    manufacturer: item.manufacturer,
						    inspect_time: item.inspectTime,
						    inspect_result: item.inspectResult,
						    inspect_cycle: item.inspectCycle,
						    dept_id: item.deptId,
						    charger: item.charger,
						    keeper: item.keeper,
						    notes: item.notes,
							spu_sn: item.spuSn
					} 
					arry.push(a)
						})
						this.lis = arry
						// this.lis.forEach((item) => {
						// 	item.price = item.price / 100
						// 	item.value = item.value / 100
						// 	item.amount = item.amount / 100
						// })
						const pagination = { ...this.pagination
						}
						pagination.total = res.data.totalCount
						this.pagination = pagination
					} else {
						this.$message.error(res.msg)
					}
					this.loading = false
				})
			},
			//重置
			reset() {
				this.serchInfo = {
					purchaseCode: '',
					createBy: '',
					status: undefined,
					buStatus: undefined,
					company_id: undefined,
					deptId: undefined,
					createTimelist: [],
				}
			},
			//搜索
			serch_get_lis() {
				this.loading = true
				this.pagination.current = 1
				this.get_list()
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.pagination.pageSize = pagination.pageSize
				this.loading = true
				this.get_list()
			}
		},
	}
</script>
<style>
	.dialog {
		display: flex;
		justify-content: space-between;
	}

	.flex {
		display: flex;
	}

	.center {
		text-align: center;
		width: 832px;
	}

	.dialog .dialog_item {
		margin-bottom: 5px;
		width: 220px;
		display: flex;
		justify-content: space-between;
	}

	.Exhi {
		display: inline-block;
		border: 1px solid black;
		width: 100px;
		text-align: left;
		color: steelblue;
	}

	.form_item {
		float: left;
		width: 50%;
		height: 50px;
		margin-bottom: 10px;
	}

	.form_item2 {
		float: left;
		width: 33%;
		height: 50px;
		margin-bottom: 10px;
	}

	.form_item3 {
		float: left;
		width: 100%;
		height: 50px;
		margin-bottom: 10px;
	}

	.editable-cell {
		position: relative;
	}

	.editable-cell-input-wrapper,
	.editable-cell-text-wrapper {
		padding-right: 24px;
	}

	.editable-cell-text-wrapper {
		padding: 5px 24px 5px 5px;
	}

	.editable-cell-icon,
	.editable-cell-icon-check {
		position: absolute;
		right: 0;
		width: 20px;
		cursor: pointer;
	}

	.editable-cell-icon {
		line-height: 18px;
		display: none;
	}

	.editable-cell-icon-check {
		line-height: 28px;
	}

	.editable-cell:hover .editable-cell-icon {
		display: inline-block;
	}

	.editable-cell-icon:hover,
	.editable-cell-icon-check:hover {
		color: #108ee9;
	}

	.editable-add-btn {
		margin-bottom: 8px;
	}

	.border_a_input {
		border: 1px solid #ddd;
	}

	.view_path {
		width: 100%;
		float: left;
		cursor: pointer;
	}
	.note{
		color: #f5222d !important;
	}
</style>
